module.exports = __webpack_public_path__ + "static/img/gywmss.5b562aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gywmss.png
// module id = 0Twk
// module chunks = 0